import React from "react";
import { Container, Title, Description } from "./styles";
import PropTypes from "prop-types";
import { CloudinaryImage } from "@website-builder/ui/shared/elements";
const Card = ({
	image,
	title,
	description,
	linkColor = "#551A8B",
	isDescriptionRichText = false,
}) => (
	<Container>
		<CloudinaryImage
			url={image.imageUrl}
			quality="auto"
			fetchFormat="auto"
			drp="1.0"
			sizes={{
				default: {
					height: 60,
				},
				"1120px": {
					height: 60,
				},
			}}
			alt={image.alt}
			lazyload
		></CloudinaryImage>
		{title && <Title>{title}</Title>}
		{isDescriptionRichText ? (
			<Description
				linkColor={linkColor}
				dangerouslySetInnerHTML={{
					__html: description,
				}}
			></Description>
		) : (
			<Description>{description}</Description>
		)}
	</Container>
);

Card.defaultProps = {
	image: {
		imageUrl: null,
		height: null,
		alt: "",
	},
	title: null,
	description: null,
};

Card.propTypes = {
	image: PropTypes.shape({}),
	title: PropTypes.string,
	description: PropTypes.string,
};
export default Card;
